export const API_URL = process.env.REACT_APP_API_URL;
export const AD_CLIENT_ID = process.env.REACT_APP_AD_CLIENT_ID;
export const AD_AUTHORITY = process.env.REACT_APP_AD_AUTHORITY;